module.exports = __webpack_public_path__ + "img/Luminosidade.e40877e6.svg";